export default function OutsideCallRouteConfig($stateProvider) {

  'ngInject';

  $stateProvider
    .state('emailVerification', {
      url: '/emailVerification',
      template: require('./verifyEmailChange.html'),
      controller: 'VerifyChangeEmail'
    });
}